import React from "react";

import { Sidebar } from "App/Molecules/Sidebar";
import { useAppSelector } from "App/Store-v3";
import { SideNavigatorTemplate } from "App/Templates/SideNavigatorTemplate";

export const LeftSideBar = () => {
  const isOpenSidebar = useAppSelector(store => store.Sidebar.isOpen);

  return (
    <Sidebar isDrawer={true} isOpen={isOpenSidebar}>
      <SideNavigatorTemplate />
    </Sidebar>
  );
};
